import { breakpoints } from './media';

export function getElementTop(element) {
  let y = 0;
  let curElement = element;
  while (curElement) {
    y += curElement.offsetTop;
    curElement = curElement.offsetParent;
  }
  return y;
}

export function getElementBottom(element) {
  return getElementTop(element) + element.offsetHeight;
}

export function getScrollPosition(element) {
  return {
    x: Math.max(0, element.scrollLeft),
    y: Math.max(0, element.scrollTop),
  };
}

export function setScrollPosition(element, x, y) {
  element.scrollLeft = Math.max(
    0,
    Math.min(
      element.scrollWidth -
        Number.parseInt(window.getComputedStyle(element).width, 10),
      x,
    ),
  );
  element.scrollTop = Math.max(0, y);
}

export const getWindowSize = () => {
  if (typeof window === 'undefined') {
    return {
      unknown: true,
      breakpoints: {},
    };
  }

  const width = window.innerWidth || document.documentElement.clientWidth;
  const height = window.innerHeight || document.documentElement.clientHeight;

  const bpMap = Object.keys(breakpoints).reduce((acc, name) => {
    acc[name] = breakpoints[name] <= width;
    return acc;
  }, {});

  return {
    width,
    height,
    breakpoints: bpMap,
  };
};
